import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-yellow.svg'
import _imports_1 from '@/app/ui/assets/svg/close-icon-notif.svg'


const _hoisted_1 = { class: "font-semibold text-20px" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "font-semibold mb-2 text-14px" }
const _hoisted_4 = { class: "border border-gray-lp-200 rounded-lg py-2 flex flex-row items-center bg-white shadow-sm" }
const _hoisted_5 = { class: "flex flex-col items-center w-1/3 border-r border-gray-lp-200 px-2" }
const _hoisted_6 = { class: "text-gray-lp-500 text-12px mb-1" }
const _hoisted_7 = {
  key: 0,
  class: "bg-yellow-lp-200 text-yellow-lp-100 px-3 py-1 rounded-full flex items-center gap-1 text-12px font-semibold"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 h-4"
}, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "bg-red-lp-600 text-red-lp-100 px-3 py-1 rounded-full flex items-center gap-1 text-12px font-semibold"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4 h-4"
}, null, -1)
const _hoisted_11 = { class: "flex flex-col items-center w-1/3 border-r border-gray-lp-200 px-2" }
const _hoisted_12 = { class: "text-gray-lp-500 text-12px mb-1" }
const _hoisted_13 = { class: "font-semibold text-center text-14px" }
const _hoisted_14 = { class: "text-gray-lp-500 text-12px" }
const _hoisted_15 = { class: "flex flex-col items-center w-1/3 px-2" }
const _hoisted_16 = { class: "text-gray-lp-500 text-12px mb-1" }
const _hoisted_17 = { class: "font-semibold text-16px" }
const _hoisted_18 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_19 = { class: "font-semibold mb-2 text-14px" }
const _hoisted_20 = { class: "border border-gray-lp-200 rounded-lg bg-white shadow-sm" }
const _hoisted_21 = { class: "text-gray-lp-600" }
const _hoisted_22 = { class: "font-semibold text-14px" }
const _hoisted_23 = { class: "text-gray-lp-600" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" oleh ")
const _hoisted_25 = { class: "font-semibold text-black" }
const _hoisted_26 = { class: "mb-2" }
const _hoisted_27 = { class: "font-semibold mb-2 text-14px" }
const _hoisted_28 = { class: "bg-gray-lp-1000 p-3 rounded-lg gap-4 flex items-center text-14px mt-4" }
const _hoisted_29 = { class: "text-gray-lp-500" }
const _hoisted_30 = { class: "font-semibold text-red-lp-100" }
const _hoisted_31 = { class: "flex w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_ModalSuccessReceipt = _resolveComponent("ModalSuccessReceipt")!
  const _component_InvoicePdfStruk = _resolveComponent("InvoicePdfStruk")!
  const _component_InvoicePdfA4 = _resolveComponent("InvoicePdfA4")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.showSuccessModal)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 0,
          width: "w-5/12",
          onClose: _ctx.onClose,
          isCustomTitle: true,
          showFooter: true,
          isShadows: false,
          footerBgColor: "bg-white",
          borderTop: ""
        }, {
          "custom-title": _withCtx(() => [
            _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("tagihan.modal.updateLunas")) + " - " + _toDisplayString(_ctx.invoiceData.invoiceNumber), 1)
          ]),
          content: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("tagihan.modal.invoiceInfo")), 1),
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("tagihan.table.status")), 1),
                  (_ctx.invoiceData.status === 'PARTIAL')
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _hoisted_8,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("tagihan.status.partiallyPaid")), 1)
                      ]))
                    : (_ctx.invoiceData.status === 'UNPAID' || !_ctx.invoiceData.status)
                      ? (_openBlock(), _createBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("tagihan.status.unpaid")), 1)
                        ]))
                      : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("tagihan.form.billedTo")), 1),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", null, _toDisplayString(_ctx.invoiceData.customerName), 1),
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.maskingPhoneNumber), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("tagihan.table.totalAmount")), 1),
                  _createVNode("div", _hoisted_17, _toDisplayString(_ctx.formatCurrency(_ctx.invoiceData.totalAmount)), 1)
                ])
              ])
            ]),
            (
          _ctx.invoiceData.paymentHistory && _ctx.invoiceData.paymentHistory.length > 0
        )
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("tagihan.modal.paymentHistory")), 1),
                  _createVNode("div", _hoisted_20, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invoiceData.paymentHistory, (history, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        class: ["p-4 flex justify-between items-center text-14px", 
              index !== _ctx.invoiceData.paymentHistory.length - 1
                ? 'border-b border-gray-lp-200'
                : ''
            ]
                      }, [
                        _createVNode("div", _hoisted_21, _toDisplayString(_ctx.formatDateHistory(history.date)), 1),
                        _createVNode("div", _hoisted_22, _toDisplayString(_ctx.formatCurrency(history.amount)), 1),
                        _createVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createVNode("span", _hoisted_25, _toDisplayString(history.user), 1)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("tagihan.modal.payment")), 1),
              _createVNode(_component_LpInput, {
                modelValue: _ctx.paymentAmount,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.paymentAmount = $event)),
                type: "text",
                placeholder: "0",
                format: _ctx.formatMoney,
                prefix: _ctx.currencyPrefix,
                class: "mb-2",
                error: _ctx.isPaymentExceedsRemaining,
                errorCaption: _ctx.$t('tagihan.modal.amountExceeds')
              }, null, 8, ["modelValue", "format", "prefix", "error", "errorCaption"]),
              _createVNode("div", _hoisted_28, [
                _createVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("tagihan.modal.remainingAmount")), 1),
                _createVNode("span", _hoisted_30, _toDisplayString(_ctx.formatCurrency(_ctx.remainingAmount)), 1)
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_31, [
              _createVNode(_component_LpButton, {
                title: _ctx.$t('tagihan.modal.updateInvoice'),
                color: _ctx.isDisabled ? 'gray-lp-400' : 'red-lp-100',
                "text-color": "white",
                isWidthFull: true,
                disabled: _ctx.isDisabled || _ctx.isLoading,
                loading: _ctx.isLoading,
                onClick: _ctx.onSubmit
              }, null, 8, ["title", "color", "disabled", "loading", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showSuccessModal)
      ? (_openBlock(), _createBlock(_component_ModalSuccessReceipt, {
          key: 1,
          visible: _ctx.showSuccessModal,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSuccessModal = $event)),
          mode: "update",
          invoiceData: _ctx.successData,
          onClose: _ctx.onClose,
          onDownload: _ctx.handleDownload
        }, null, 8, ["visible", "invoiceData", "onClose", "onDownload"]))
      : _createCommentVNode("", true),
    _createVNode(_component_InvoicePdfStruk, {
      ref: "struk",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"]),
    _createVNode(_component_InvoicePdfA4, {
      ref: "invoice",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"])
  ], 64))
}